import { getActiveSchool, getActiveSchoolId, isViewingDemoSchool } from './activeSchool';

export class NoSchoolContextError extends Error {
    constructor() {
        super('no_school_context');
        this.name = 'NoSchoolContextError';
    }
}

function getSessionRole() {
    if (typeof window === 'undefined') return '';
    return localStorage.getItem('role') || '';
}

/** Платформенный админ не привязан к одной школе — не дергаем /school/my. */
export function isPlatformAdminRole() {
    return getSessionRole() === 'Admin';
}

// Ответ axios: .data
export async function getMySchool(api, schoolId) {
    if (isPlatformAdminRole()) {
        throw new NoSchoolContextError();
    }

    const id = schoolId ?? getActiveSchoolId();
    const params = id ? { schoolId: id } : {};
    try {
        return await api.get('/school/my', { params });
    } catch (err) {
        if (err.response?.status === 404) {
            return await api.get('/school/context');
        }
        throw err;
    }
}

/** Школа в контексте выбранной сессии (владелец / тренер / ученик / демо). */
export async function getSchoolForSession(api) {
    if (isPlatformAdminRole()) {
        throw new NoSchoolContextError();
    }

    const active = getActiveSchool();
    if (active?.schoolId && (active.accessRole === 'owner' || isViewingDemoSchool())) {
        return api.get('/school/my', { params: { schoolId: active.schoolId } });
    }
    if (active?.schoolId) {
        return api.get(`/school/${active.schoolId}/brief`);
    }
    return getMySchool(api);
}

export function getSchoolIdFromResponse(schoolRes) {
    const d = schoolRes?.data;
    if (!d) return null;
    return d.id ?? d.schoolId ?? null;
}

/** Обработка ошибки загрузки школы — без шума в консоли для ожидаемых случаев. */
export function isBenignSchoolLoadError(err) {
    if (err instanceof NoSchoolContextError || err?.name === 'NoSchoolContextError') {
        return true;
    }
    return err?.response?.status === 404;
}
